import { Link } from 'react-router';
import type { MenuItem } from 'types/capi/plp';

import { DropdownOption } from '../Dropdown';
import type { FacetSelection } from './Menus';

type Props = {
  item: MenuItem;
  menuId: string;
  onSelect: (selection: FacetSelection) => void;
};

export default function MenuOptionsListItem({ menuId, item, onSelect }: Props) {
  return (
    <DropdownOption
      canClear
      isSelected={Boolean(item.active)}
      name={menuId}
      onClick={() => onSelect(item)}
      render={
        <Link
          data-cy="desktop-filter-option"
          to={item.path}
          {...(menuId === 'PRICE_MENU' && { rel: 'nofollow' })}
        />
      }
      value={item.value ?? item.text}
    >
      {item.text}
    </DropdownOption>
  );
}
